"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const DeviceList_1 = require("./DeviceList");
const SendTestComponentLayout_1 = require("./SendTestComponentLayout");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const NoTestDevices_1 = require("./NoTestDevices");
const SendTestComponent = ({ device, buttonLeftCallback, buttonRightCallback, listOfTestDevices, selectedTestDevices, sendTestModalDisplay, updateSelectedTestDevices, showDeleteTestDevicesConfirmation, }) => {
    const handleCheck = (deviceId) => {
        const selectedDevices = new Set(selectedTestDevices);
        if (selectedDevices.has(deviceId)) {
            selectedDevices.delete(deviceId);
        }
        else {
            selectedDevices.add(deviceId);
        }
        updateSelectedTestDevices && updateSelectedTestDevices([...selectedDevices]);
    };
    const isUserOnMobile = device === 'Mobile';
    return (React.createElement(SendTestComponentLayout_1.default, { userDeviceType: device, sendTestModalDisplay: sendTestModalDisplay },
        React.createElement(src_1.NavBar, { buttonLeft: "Cancel", buttonLeftCallback: buttonLeftCallback, buttonRightCallback: buttonRightCallback, customRightElem: React.createElement(React.Fragment, null,
                React.createElement(src_1.Button, { type: "regular", onClick: showDeleteTestDevicesConfirmation, text: selectedTestDevices.length !== 0 ? 'Remove' : '', style: {
                        outerStyle: {
                            marginRight: isUserOnMobile ? 24 : 16,
                        },
                    } }),
                React.createElement(src_1.Button, { type: "regular", style: {
                        outerStyle: {
                            marginRight: isUserOnMobile ? 24 : 16,
                            color: src_1.graphite,
                        },
                    }, onClick: buttonRightCallback, text: selectedTestDevices.length !== 0 ? 'Send' : '' })), style: {
                buttonLeftStyle: {
                    outerStyle: {
                        marginLeft: isUserOnMobile ? 24 : 16,
                        color: src_1.graphite,
                    },
                    innerStyle: {
                        color: src_1.graphite,
                    },
                },
                containerStyle: {
                    minHeight: isUserOnMobile ? 56 : undefined,
                },
            } }),
        React.createElement("div", { style: {
                display: isUserOnMobile ? 'flex' : undefined,
                flexDirection: isUserOnMobile ? 'column' : undefined,
                height: isUserOnMobile ? undefined : 250,
                overflowY: isUserOnMobile ? undefined : 'scroll',
                margin: isUserOnMobile ? 24 : 0,
            } },
            isUserOnMobile && React.createElement(src_1.Text, { text: "Send a Test", size: "h1" }),
            listOfTestDevices.length === 0 ? (React.createElement(NoTestDevices_1.default, { userDeviceType: device })) : (React.createElement(DeviceList_1.default, { selectedDeviceIds: selectedTestDevices, devices: listOfTestDevices, handleSelectDevice: handleCheck, userDeviceType: device })))));
};
const mapStateToProps = (state) => ({
    sendTestModalDisplay: reducers_1.getIsSendTestModalOpen(state),
    selectedTestDevices: reducers_1.getSelectedTestDevices(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateSelectedTestDevices: (deviceIds) => {
            dispatch(actions_1.updateSelectedTestDevices(deviceIds));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SendTestComponent);
